import {Field, Input, InputGroup, InputGroupProps} from '@chakra-ui/react'

export function DisplayInput({
  label,
  value,
  hideLabel,
  inputGroupProps,
}: {
  label?: string
  value?: string
  hideLabel?: boolean
  inputGroupProps?: Omit<InputGroupProps, 'children'>
}) {
  return (
    <Field.Root disabled>
      <Field.Label srOnly={hideLabel}>{label}</Field.Label>

      <InputGroup {...inputGroupProps}>
        <Input backgroundColor="bg" value={value ?? ''} />
      </InputGroup>
    </Field.Root>
  )
}
